<template>
	<div>
		<slot></slot>
		<div class="vx-card p-6">
			<div class="flex flex-wrap items-center justify-end" v-if="resourceListConfig.tableOptions">
				<!-- ITEMS PER PAGE -->
				<div class="flex items-center flex-grow">
					<vs-dropdown v-if="resourceListConfig.showItemsPerPage" vs-trigger-click class="cursor-pointer">
						<div
							class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
						>
							<span class="mr-2"
								>{{
									paginationPageSize === 0
										? 0
										: currentPage * paginationPageSize - (paginationPageSize - 1)
								}}
								-
								{{
									resourcesData.length - currentPage * paginationPageSize > 0
										? currentPage * paginationPageSize
										: resourcesData.length
								}}
								{{ $t("Of") }} {{ pagination.total_records }}</span
							>
							<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
						</div>
						<vs-dropdown-menu style="z-index: 54000">
							<vs-dropdown-item @click="paginationSetPageSize(20)">
								<span>20</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="paginationSetPageSize(50)">
								<span>50</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="paginationSetPageSize(100)">
								<span>100</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="paginationSetPageSize(200)">
								<span>200</span>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
					<div v-else>
						<span class="font-bold text-2xl">{{ getCheckedResources.length + " " }}</span>
						<span style="font-size: 1em; font-weight: 400">{{
							getCheckedResources.length > 1
								? $t("ResourceModule.SelectedResourcesFrom")
								: $t("ResourceModule.ResourceSelectedFrom")
						}}</span>
						<span class="font-bold text-2xl">{{ " " + resourcesData.length }}</span>
					</div>
				</div>
				<template>
					<!-- ITEMS PER PAGE -->
					<vs-dropdown vs-trigger-click class="cursor-pointer">
						<div
							class="p-3 mt-1 mr-2 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer font-medium"
						>
							<span class="mr-2">{{ $t("SearchBy") }} {{ searchSelected }}</span>
							<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
						</div>
						<vs-dropdown-menu style="z-index: 54000">
							<vs-dropdown-item @click="setSearchField('Identification')">
								<span>{{ $t("ResourceModule.Table.Identification") }}</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="setSearchField('Name')">
								<span>{{ $t("ResourceModule.Table.Name") }}</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="setSearchField('Email')">
								<span>{{ $t("ResourceModule.Table.Email") }}</span>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
				</template>
				<!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
				<div class="vx-col md:w-1/3 sm:w-1/2 w-full p-0">
					<vx-tooltip
						class="cursor-pointer"
						color="primary"
						position="bottom"
						delay=".1s"
						:title="$t('Search')"
						:text="$t('SearchSeparatedByCommas') + '.'"
					>
						<tags-input
							element-id="tags"
							v-model="searchQuery"
							add-tags-on-comma
							add-tags-on-blur
							:placeholder="$t('Teams.Form.Add') + ' ' + searchSelected"
							:typeahead="true"
							@keyup.enter="searchResource"
						></tags-input>
					</vx-tooltip>
				</div>
				<vs-button
					class="ml-2"
					color="primary"
					icon-pack="feather"
					icon="icon-search"
					:title="$t('VisitPoints.Search')"
					@click.prevent="searchResource"
				></vs-button>
				<vs-button
					class="ml-2"
					color="primary"
					icon-pack="feather"
					icon="icon-refresh-cw"
					:title="$t('Refresh')"
					@click.prevent="refreshResource()"
				></vs-button>
				<vs-button
					v-if="resourceListConfig.showBtnNewResource"
					class="ml-2"
					color="primary"
					icon-pack="feather"
					icon="icon-plus"
					:title="$t('Add') + ' ' + $t('Resource')"
					@click.prevent="addNewResource()"
				></vs-button>
				<vs-dropdown
					vs-custom-content
					:vs-trigger-click="true"
					class="cursor-pointer"
					:title="$t('Setting.Setting')"
				>
					<vs-button class="ml-2" type="filled" icon-pack="feather" icon="icon-settings"></vs-button>
					<vs-dropdown-menu style="z-index: 54000; width: 30%">
						<vx-card no-shadow :title="$t('Setting.Setting')">
							<div class="flex flex-row justify-between p-1">
								<p class="mr-2">{{ $t("Preferences.FindExactly") }}</p>
								<vs-switch color="success" v-model="isExactly" @input="openEnableConfirm"></vs-switch>
							</div>
						</vx-card>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>
			<!-- AgGrid Table -->
			<ag-grid-vue
				ref="agGridTable"
				:components="components"
				:gridOptions="gridOptions"
				class="ag-theme-material w-100 my-4 ag-grid-table"
				:class="[!resourceListConfig.tableOptions && 'pt-12', {'ag-customizer-container': !isWidthPortatil}]"
				:columnDefs="columnDefs"
				:defaultColDef="defaultColDef"
				:rowData="resourcesData"
				:rowSelection="resourceListConfig.rowSelection"
				colResizeDefault="shift"
				:animateRows="true"
				:pagination="true"
				:paginationPageSize="paginationPageSize"
				:suppressPaginationPanel="true"
				:enableRtl="$vs.rtl"
				:overlayNoRowsTemplate="overlayNoRowsTemplate"
				:overlayLoadingTemplate="overlayLoadingTemplate"
				:enableCellTextSelection="true"
				@selection-changed="onSelectionChanged"
				@rowSelected="rowSelected"
			>
			</ag-grid-vue>
			<vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
		</div>
	</div>
</template>

<script>
import {resourceListMixin} from "../model/ResourceListMixin";

export default {
	mixins: [resourceListMixin],
};
</script>

<style lang="scss" scoped>
#page-user-list {
	padding: 15px;
	.user-list-filters {
		.vs__actions {
			position: absolute;
			right: 0;
			top: 50%;
			transform: translateY(-58%);
		}
	}
}
</style>
